import { VISIBLE } from 'src/constants/appConstants';
import {convertDataRpToRecord, getValidateItemsArr} from '../utils/dataModificaionUtil';

const progressBarIconClickHandlerUtil = ({
    step,
    isDraft,
    procedureTypeUsageVisibility,
    proceduresList,
    dispatch,
    getDropdownOptionsRequest,
    procedureInfoDetails,
    usageDetails,
    salesOrg,
    setProcedureDropdownValue,
    getProcedureInfoRequest,
    setProgressBarClicked,
    setStep,
    patientDetails,
    filteredProduct,
    myCaseRefId,
    validateProductDetails,
    setPatientDetails,
}) => {
    if (step === 'Procedure' && isDraft) {
        if (
            !(
                procedureTypeUsageVisibility === VISIBLE &&
                proceduresList?.length > 0
            )
        ) {
            dispatch(getDropdownOptionsRequest('procedures'));
        }
        if (
            !(
                procedureInfoDetails &&
                Object.keys(procedureInfoDetails).length > 0
            )
        ) {
            const data = {
                procedureCode:
                    procedureTypeUsageVisibility === VISIBLE &&
                    usageDetails?.procedureCode
                        ? usageDetails?.procedureCode
                        : '',
                salesOrg: salesOrg,
            };
            setProcedureDropdownValue({
                procedureCode: usageDetails?.procedureCode,
                procedureDescription: usageDetails?.procedureDescription,
            });
            dispatch(getProcedureInfoRequest('Usage', data));
        }
    }
    setProgressBarClicked(true);
    setStep(step);
    dispatch(setPatientDetails(patientDetails));
    const validateItemsArr = getValidateItemsArr(convertDataRpToRecord(filteredProduct));
    validateItemsArr.map(
        (item) => item.accountOwned == undefined && delete item.accountOwned
    );
    const validateItemsObj = {
        myCaseRef: myCaseRefId,
        products: validateItemsArr,
    };
    dispatch(validateProductDetails(validateItemsObj, true));
    dispatch({
        type: 'SET_ITEMS_PRICING_DONE_FLAG',
        payload: false,
    });
};

export default progressBarIconClickHandlerUtil;
